const SENSITIVE_KEYS = new Set(['password', 'token', 'authorization', 'secret', 'ssn', 'creditcard', 'credit_card']);
const MAX_BODY_BYTES = 1024;

export function sanitize(value: unknown, seen: WeakSet<object> = new WeakSet()): unknown {
  if (value === null || typeof value !== 'object') return value;
  if (seen.has(value as object)) return '[Circular]';
  seen.add(value as object);
  if (Array.isArray(value)) return value.map((item) => sanitize(item, seen));
  const out: Record<string, unknown> = {};
  for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
    out[key] = SENSITIVE_KEYS.has(key.toLowerCase()) ? '[REDACTED]' : sanitize(val, seen);
  }
  return out;
}

export function truncateBody(body: unknown): unknown {
  if (body === null || body === undefined) return body;
  const sanitized = sanitize(body);
  let serialized: string;
  try {
    serialized = typeof sanitized === 'string' ? sanitized : JSON.stringify(sanitized);
  } catch {
    return '[unserializable]';
  }
  return serialized.length > MAX_BODY_BYTES ? `${serialized.slice(0, MAX_BODY_BYTES)}...[truncated]` : sanitized;
}
